import React, { useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { Card, Input, Button, message, Typography } from 'antd';

const { Title, Text } = Typography;

export default function SetPassword() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');
  const navigate = useNavigate();

  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async () => {
    if (!password || password.length < 8) {
      message.error('Password must be at least 8 characters');
      return;
    }
    if (password !== confirmPassword) {
      message.error('Passwords do not match');
      return;
    }

    setLoading(true);
    try {
      const res = await fetch('/api/auth/set-password', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ token, password }),
      });
      const data = await res.json();

      if (res.ok && data.success) {
        message.success('Password set successfully! Redirecting to login...');
        setTimeout(() => navigate('/login'), 2000);
      } else {
        message.error(data.message || 'Failed to set password');
      }
    } catch {
      message.error('Connection error');
    } finally {
      setLoading(false);
    }
  };

  if (!token) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh', background: '#f5f8fb' }}>
        <Card style={{ maxWidth: 400, textAlign: 'center' }}>
          <Title level={4}>Invalid Link</Title>
          <Text>This invitation link is invalid or has expired.</Text>
        </Card>
      </div>
    );
  }

  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh', background: '#f5f8fb' }}>
      <Card style={{ width: 420, boxShadow: '0 4px 12px rgba(0,0,0,0.08)' }}>
        <Title level={3} style={{ textAlign: 'center', marginBottom: 8 }}>Set Your Password</Title>
        <Text type="secondary" style={{ display: 'block', textAlign: 'center', marginBottom: 24 }}>
          Create a password to activate your account
        </Text>

        <div style={{ marginBottom: 16 }}>
          <label style={{ display: 'block', marginBottom: 6, fontWeight: 600 }}>Password</label>
          <Input.Password
            placeholder="Min. 8 characters"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            size="large"
          />
        </div>

        <div style={{ marginBottom: 16 }}>
          <label style={{ display: 'block', marginBottom: 6, fontWeight: 600 }}>Confirm Password</label>
          <Input.Password
            placeholder="Confirm your password"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            size="large"
          />
        </div>

        <Button type="primary" block size="large" loading={loading} onClick={handleSubmit}>
          Activate Account
        </Button>
      </Card>
    </div>
  );
}
